<div class="send-to-header"
     data-testid="send-to-header">
  <img src="assets/icons/send.svg"
       alt=""
       aria-hidden="true"
       class="send-icon"
       data-testid="send-to-icon" />
  <span class="send-to-label body-md-bold"
        data-testid="send-to-label">Send to:</span>
</div>


@if (contacts()!.length > 0) {
  <div class="managed-contact-list"
       data-testid="managed-contact-list">
    @for (contact of contacts()!; track contact.id; let contactIndex = $index) {
      <div class="managed-contact-chip"
           [attr.data-testid]="'managed-contact-chip-' + contact.id">
        <p-checkbox [binary]="true"
                    [ngModel]="isContactSelected(contact)"
                    (ngModelChange)="onContactSelectionChange(contact, $event)"
                    [inputId]="'send-to-contact-' + contactIndex"
                    [attr.data-testid]="'send-to-contact-checkbox-' + contact.id">
          <ng-template #checkboxicon
                       let-checked="checked"
                       let-iconClass="class">
            @if (checked) {
              <img src="assets/icons/material-symbols_check.svg"
                   alt=""
                   aria-hidden="true"
                   [class]="iconClass" />
            }
          </ng-template>
        </p-checkbox>
        <label class="managed-contact-email body-md-regular"
               [for]="'send-to-contact-' + contactIndex">{{ contact.email }}</label>
        <button type="button"
                class="managed-contact-edit-btn"
                (click)="onEditContact(contact)"
                [attr.aria-label]="'Edit contact ' + contact.email"
                [attr.data-testid]="'managed-contact-edit-' + contact.id">
          <i class="pi pi-pencil"
             aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
}

@if (externalVendorId !== null) {
  <p-button [label]="contacts()!.length > 0 ? 'Add Another Contact' : 'Add Contact'"
            type="button"
            severity="contrast"
            [outlined]="true"
            styleClass="bqa-primary-btn p-fullwidth-button"
            (onClick)="onAddContact()"
            data-testid="send-to-add-contact-btn" />
}

<!-- Add / Edit contact bottom sheet -->
<app-bottom-sheet class="contact-sheet-host"
                  [isOpen]="showContactSheet()"
                  [hasFooter]="false"
                  [isFullScreen]="false"
                  [preventOverlayClose]="isSaving()"
                  [backgroundClass]="showAnimations() ? 'contact-sheet-slide' : ''"
                  [headerTemplate]="contactFormHeader"
                  [contentTemplate]="contactFormContent"
                  (isOpenChange)="onContactSheetOpenChange($event)"
                  data-testid="send-to-contact-sheet">
</app-bottom-sheet>

<ng-template #contactFormHeader>
  <div class="contact-sheet-header"
       data-testid="edit-vendor-contact-header">
    @if(showBackButton()) {
      <p-button type="button"
                icon="pi pi-arrow-left"
                severity="secondary"
                [text]="true"
                [disabled]="isSaving()"
                styleClass="bqa-secondary-btn contact-back-btn"
                (onClick)="onContactCancel()"
                ariaLabel="Go back"
                data-testid="edit-vendor-contact-back-btn" />
    }
    <h2 class="contact-sheet-title body-lg-bold"
        data-testid="edit-vendor-contact-title">
      {{ formMode() === 'add' ? 'Add Contact' : 'Edit Contact' }}
    </h2>
  </div>
</ng-template>

<ng-template #contactFormContent>
  <div [class.contact-form-slide]="showAnimations()"
       [class.open]="isContactFormOpen()"
       [class.contact-form-no-animation]="!showAnimations() && isContactFormOpen()"
       (transitionend)="onContactFormTransitionEnd($event)">
    <app-edit-vendor-contact [mode]="formMode()"
                             [contact]="editingContact()"
                             [vendorName]="vendorName()"
                             [isSaving]="isSaving()"
                             [loadingAction]="loadingAction()"
                             [resetVersion]="formResetVersion()"
                             (save)="onContactSave($event)"
                             (saveAndAddAnother)="onContactSaveAndAddAnother($event)"
                             (delete)="onContactDelete($event)"
                             (cancel)="onContactCancel()"
                             data-testid="send-to-edit-vendor-contact">
    </app-edit-vendor-contact>
  </div>
</ng-template>